import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { User } from '@app/user/_models/user';
import Utils from '@app/shared/utils';
import { Clipboard } from "@angular/cdk/clipboard"

@Injectable({ providedIn: 'root' })
export class UserService {
    public userSubject: BehaviorSubject<User>;
    public user: Observable<User>;

    constructor(
        public router: Router,
        public http: HttpClient,
        public clipboard: Clipboard
    ) {
        this.userSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('user')));
        this.user = this.userSubject.asObservable();
    }

    public get userValue(): User {
        return this.userSubject.value;
    }

    login(username, password) {
       /*  return this.http.post<User>(`${environment.apiUrl}/users/authenticate`, { username, password })
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
                this.userSubject.next(user);
                return user;
            })); */
        return this.http.post(`${environment.apiUrl}/dashboard/user/authenticate`, { username, password })
        .pipe(map(res => {
            if(res["success"] == true ){
                const user = res["user"];                
                user['facility'] = user['facilityAndRoles'][0];
                localStorage.setItem('user', JSON.stringify(user));
                this.userSubject.next(user);
                return user;
            }
            else{
                return res;
            }
        }));
    }

    checkAccount(username, password) {
        return this.http.post(`${environment.originUrl}/dashboard/user/authenticate`, { username, password })
        .pipe(
            map(res => {
                if(res["success"] == true ){
                    const user = res["user"];                
                    return user;
                } else {
                    return res;
                }
            })
        );
    }

    linkAccount(id, params) {
        return this.http.put(`${environment.apiUrl}/dashboard/user/edit?id=${id}`, params)
            .pipe(
                map(x => {    
                    return x;
                })
            );
    }

    selectProfile(profile) {
        const user = profile;                
        user['facility'] = user['facilityAndRoles'][0];
        localStorage.setItem('user', JSON.stringify(user));
        this.userSubject.next(user);
        // return of(profile)
    }

    logout() {
        // remove user from local storage and set current user to null
        localStorage.removeItem('user');
        this.userSubject.next(null);
        this.router.navigate(['/login']);
    }

    register(user: User) {
        var tempPassword = Utils.generateGuid()
        this.clipboard.copy(tempPassword);
        if(!environment.isDesktop)
            alert("GENERATED TEMPORARY PASSWORD: "+ tempPassword +". IMPORTANT: Please take note of the temporary password to be sent to the user. In the event that the temporary password is lost, a new temporary password can be generated later.");  
        user["password"] = tempPassword
        user["hasTemporaryPassword"] = !environment.isDesktop
        return this.http.post(`${environment.apiUrl}/dashboard/user/add`, user);
    }

    registerUpload(user: User) {
        user["hasTemporaryPassword"] = true;
        return this.http.post(`${environment.apiUrl}/dashboard/user/add`, user);
    }

    edit(id, params) {
        return this.http.put(`${environment.apiUrl}/users/${id}`, params)
            .pipe(map(x => {
                // update stored user if the logged in user updated their own record
                if (id == this.userValue.id) {
                    // update local storage
                    const user = { ...this.userValue, ...params };
                    localStorage.setItem('user', JSON.stringify(user));

                    // publish updated user to subscribers
                    this.userSubject.next(user);
                }
                return x;
            }));
    }

    getById(id: string) {
        return this.http.get<User>(`${environment.apiUrl}/dashboard/user/get?id=${id}`);
    }

    getOriginById(id: string) {
        return this.http.get<User>(`${environment.originUrl}/dashboard/user/get?id=${id}`);
    }
    
    update(id, params) {
        return this.http.put(`${environment.apiUrl}/dashboard/user/edit?id=${id}`, params)
            .pipe(map(x => {
                // update stored user if the logged in user updated their own record
              /*   if (id == this.userValue.id) {
                    // update local storage
                    const user = { ...this.userValue, ...params };
                    localStorage.setItem('user', JSON.stringify(user));

                    // publish updated user to subscribers
                    this.userSubject.next(user);
                } */
                return x;
            }));
    }

    resetPassword(id, params) {
        var tempPassword = Utils.generateGuid();
        this.clipboard.copy(tempPassword);
        alert("GENERATED TEMPORARY PASSWORD: "+ tempPassword +". IMPORTANT: Please take note of the temporary password to be sent to the user. In the event that the temporary password is lost, a new temporary password can be generated later.");
        params["password"] = tempPassword;
        params["hasTemporaryPassword"] = true;
        return this.http.put(`${environment.apiUrl}/dashboard/user/edit?id=${id}`, params);
    }

    delete(id: string) {
        return this.http.delete(`${environment.apiUrl}/dashboard/user/delete?id=${id}`)
            .pipe(map(x => {
                /* // auto logout if the logged in user deleted their own record
                if (id == this.userValue.id) {
                    this.logout();
                } */
                return x;
            }));
    }

    setCurrentFacility(idx: number, user: User) {
        user['facility'] = user['facilityAndRoles'][idx];
        localStorage.setItem('user', JSON.stringify(user));
        this.userSubject.next(user);
        return of(user);
    }
}
